import { render, staticRenderFns } from "./DemandDetailsCard.vue?vue&type=template&id=20dce284&"
import script from "./DemandDetailsCard.vue?vue&type=script&lang=js&"
export * from "./DemandDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./DemandDetailsCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports